import type { Component } from 'vue';
import FallbackInterpreter from './FallbackInterpreter.vue';
import PeppolInterpreter from './PeppolInterpreter.vue';

/** Which interpreter renders is driven by interchange channel. */
export function interpreterForChannel(channel: string): Component {
	if (channel === 'PEPPOL') {
		return PeppolInterpreter;
	}
	return FallbackInterpreter;
}

export { FallbackInterpreter, PeppolInterpreter };
